export function isPresentInWidgetsMap({ widgetsMap }) {
  return function filterer(widget) {
    return !!widgetsMap[widget.name];
  };
}

export function checkWidgetPredicate(options) {
  return function filterer(widget) {
    return (
      options.widgetsMap?.[widget.name]?.predicate?.({ ...options, widget }) ??
      true
    );
  };
}
